module.exports = function (object) {
    return 'R$ ' + Inputmask.format(object, {'alias': 'money'});
};


// WEBPACK FOOTER //
// ./resources/assets/javascript/templates/money.js